import { render, staticRenderFns } from "./newdateTable.vue?vue&type=template&id=a08aaa1c&scoped=true&"
import script from "./newdateTable.vue?vue&type=script&lang=js&"
export * from "./newdateTable.vue?vue&type=script&lang=js&"
import style0 from "./newdateTable.vue?vue&type=style&index=0&id=a08aaa1c&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08aaa1c",
  null
  
)

export default component.exports